import {
  Dialog,
  DialogActionFooter,
  DialogCloseButton,
  DialogCloseIcon,
  DialogContent,
  DialogDescription,
  DialogEmphasis,
  DialogHeader,
  DialogTitle,
  DialogWarning,
} from 'components/ui';
import type { FirmDocumentFolderDeleteDialogProps } from './FirmDocumentFolderDeleteDialog.props';
import { FIRM_DOCUMENT_FOLDER_DELETE_DIALOG_TEST_IDS } from './FirmDocumentFolderDeleteDialog.testIds';

const FirmDocumentFolderDeleteDialog = ({
  folderName,
  isDeleting = false,
  onClose,
  onConfirm,
  open,
}: FirmDocumentFolderDeleteDialogProps) => (
  <Dialog
    data-testid={FIRM_DOCUMENT_FOLDER_DELETE_DIALOG_TEST_IDS.dialog}
    disableEscapeKeyDown={isDeleting}
    onClose={isDeleting ? undefined : onClose}
    open={open}>
    <DialogHeader>
      <DialogTitle>Delete Folder</DialogTitle>
      <DialogCloseButton
        aria-label="Close delete folder dialog"
        disabled={isDeleting}
        onClick={onClose}>
        <DialogCloseIcon />
      </DialogCloseButton>
    </DialogHeader>
    <DialogContent>
      <DialogDescription>
        <span>
          Are you sure you want to delete the <DialogEmphasis>{folderName ?? 'selected'}</DialogEmphasis> folder?
        </span>
        <DialogWarning>
          Documents are not deleted. Files and subfolders move up one level, or to the measurement-date root for
          top-level folders.
        </DialogWarning>
      </DialogDescription>
    </DialogContent>
    <DialogActionFooter
      actionButtonTestId={FIRM_DOCUMENT_FOLDER_DELETE_DIALOG_TEST_IDS.confirmButton}
      actionLabel="Delete Folder"
      actionVisualVariant="danger"
      cancelLabel="Cancel"
      isActionLoading={isDeleting}
      isCancelDisabled={isDeleting}
      onAction={onConfirm}
      onCancel={onClose}
    />
  </Dialog>
);

export default FirmDocumentFolderDeleteDialog;
